import { queryOptions } from "@tanstack/react-query";
import dayjs from "dayjs";
import type { FindPackageAvailabilityForRangeOutputDto } from "@/app/lib/types/codegen";
import api from "../api/api";
import { getDateString } from "../utils/dates";

/**
 * @param tripId Trip package ID
 * @param date Date string in ISO format, can omit day part e.g. '2025-11'
 */
export const tripAvailabilityQueryOptions = (tripId: string, date: string) => {
  const params = {
    rangeStart: getDateString(dayjs(date).startOf("month")),
    rangeEnd: getDateString(dayjs(date).endOf("month")),
  };

  return queryOptions({
    queryKey: ["packages", tripId, "availability", params],
    queryFn: ({ signal }) =>
      api.get<FindPackageAvailabilityForRangeOutputDto>(
        `/packages/packages/${tripId}/availability`,
        {
          signal,
          params,
        },
      ),
    select: (response) => response.data.data.availability,
    enabled: Boolean(tripId && date),
    staleTime: 0,
    throwOnError: false,
  });
};
